import { render, staticRenderFns } from "./HealthOnboarding.vue?vue&type=template&id=7182d80e&scoped=true&"
import script from "./HealthOnboarding.vue?vue&type=script&lang=ts&"
export * from "./HealthOnboarding.vue?vue&type=script&lang=ts&"
import style0 from "./HealthOnboarding.vue?vue&type=style&index=0&id=7182d80e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7182d80e",
  null
  
)

export default component.exports